import { render, staticRenderFns } from "./overtime.vue?vue&type=template&id=06b5748f"
import script from "./overtime.vue?vue&type=script&lang=js"
export * from "./overtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports